import { render } from "./HeroiconsOutlineBookOpen.vue?vue&type=template&id=30457a36"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBookOpen.vue"]])

export default __exports__